export default __webpack_public_path__ + "static/media/flag.8a31a3ac.svg";